import React, { Fragment } from "react";
import FormControl from "@mui/material/FormControl";
import { InputLabel, MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import { Skeleton } from "@mui/material";
import { useCountries } from "../cspServices";

const CountrySelect = props => {
  const { onChange, value } = props;
  const countries = useCountries();

  return (
    <Fragment>
      {countries.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth>
          <InputLabel htmlFor="content-audience">Country</InputLabel>
          <Select
            value={value || ""}
            onChange={onChange}
            inputProps={{
              name: "country",
              id: "country",
            }}
          >
            {countries.data.map(country => {
              return (
                <MenuItem value={country.code} key={country.code}>
                  {country.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    </Fragment>
  );
};

export default CountrySelect;
